<template>
    <QDialog
        v-model="opened"
        @hide="close"
        @show="$nextTick(() => { $refs.name.focus() })"
    >
        <QCard class="flex column Card">
            <QBar class="bg-primary text-white">
                <div class="text-subtitle1 text-weight-medium">
                    {{ isVariant ? $t('visualization.renameVariantModal.title') : $t('visualization.renameLoopModal.title') }}
                </div>
                <QSpace />
                <QBtn
                    v-close-popup
                    dense
                    flat
                    color="white"
                    icon="close"
                    @click="close"
                />
            </QBar>
            <q-card-section class="q-pt-none q-px-lg Body">
                <QForm
                    class="align-center q-gutter-md q-ma-md"
                    onSubmit="return false;"
                    @submit="handleRename"
                >
                    <QInput
                        ref="name"
                        v-model="newName"
                        :label="isVariant ? $t('visualization.renameVariantModal.name') : $t('visualization.renameLoopModal.name')"
                        outlined
                        stackLabel
                        dense
                        :rules="[val => !!val || $t('visualization.variantRenameRequired'),
                                 val => (val.length >= 1 && val.length <= 100) || $t('visualization.variantRenameLengthError')]"
                    />
                    <QBtn
                        :label="$t('visualization.renameVariantModal.submit')"
                        noCaps
                        color="primary"
                        outline
                        @click="handleRename"
                    />
                </QForm>
            </q-card-section>
        </QCard>
    </QDialog>
</template>
<script>
import VueTypes from 'vue-types'

export default {
    name: 'RenameComponent',
    components: {},
    props: {
        isVariant: VueTypes.bool,
    },
    emits: ['save'],
    data() {
        return {
            opened: false,
            newName: undefined,
        }
    },
    methods: {
        focusInput() {
            this.$nextTick(() => {
                this.$refs.name.$el.focus()
            })
        },
        open() {
            this.reset()
            this.opened = true
            this.$nextTick(() => {
                this.focusInput()
            })
        },
        close() {
            this.opened = false
        },
        reset() {
            this.newName = undefined
        },
        handleRename() {
            if (this.$refs.name.validate()) {
                this.$emit('save', {
                    newName: this.newName,
                })
            }
        },
    },
}
</script>
<style scoped lang="scss">
.Card .Body {
    min-width: 500px
}
.Header {
    padding-bottom:0px;
}
</style>
